'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactAddonsPureRenderMixin = require('react-addons-pure-render-mixin');

var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactUtils = require('react-utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _react2.default.createClass({
  displayName: 'UITypeaheadResults',

  mixins: [_reactAddonsPureRenderMixin2.default],

  propTypes: {
    children: _react.PropTypes.node,
    className: _react.PropTypes.string,
    onScroll: _react.PropTypes.func
  },

  render: function render() {
    var _props = this.props,
        children = _props.children,
        className = _props.className,
        onScroll = _props.onScroll;

    return _react2.default.createElement(
      'ul',
      {
        className: (0, _reactUtils.classNames)('private-typeahead-results', className),
        onScroll: onScroll,
        role: 'listbox'
      },
      children
    );
  }
});
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1282/js/typeahead/results/UITypeaheadResults.js
// module id = 155
// module chunks = 0